import React from 'react'

import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { fetchReservation } from 'actions/reservation'
import ReservationSearchBox from 'components/forms/reservation-search-box'
import { IconNames } from 'components/icons'
import { searchBox as e2eClasses } from 'constants/e2eClasses'
import NAMESPACES from 'localization/constants/namespaces'

const MyReservationSearchBox = ({ onReserveError, onButtonClick, fetchReservation, label }) => {
  const { t } = useTranslation(NAMESPACES.HOME)

  const handleButtonClick = (reservationCode, lastName) => {
    onReserveError && onReserveError()
    onButtonClick && onButtonClick()
    fetchReservation(reservationCode, lastName)
  }

  return (
    <ReservationSearchBox
      onSearch={handleButtonClick}
      labels={{
        title: t('shopping.search-box-container.search-my-reservation'),
        search: label || t('shopping.search-box-container.search-my-reservation.uppercase'),
        codeBox: e2eClasses.reserveBox,
        searchButton: e2eClasses.reserveSearchButton,
        pnr: {
          codeBox: e2eClasses.reserveCodeBox,
          codeTitle: e2eClasses.reserveCodeTitle,
          iconName: IconNames.Airplane,
          labelMobile: t('shopping.search-box-container.pnr-placeholder'),
          label: t('label.reservation-code'),
          code: e2eClasses.reserveCode,
          error: t('shopping.search-box-container.validation.pnr.required')
        },
        lastName: {
          codeBox: e2eClasses.reservePassengerBox,
          codeTitle: e2eClasses.reservePassengerTitle,
          iconName: IconNames.HumanMale,
          label: t('label.passenger', { count: 1 }),
          placeholder: t('label.lastname'),
          code: e2eClasses.reservePassenger,
          error: t('shopping.search-box-container.validation.last-name.required')
        }
      }}
    />
  )
}

const mapDispatchToProps = {
  fetchReservation
}

export default connect(null, mapDispatchToProps)(MyReservationSearchBox)
